// Central content for Smart Living Interiors

export const BRAND = {
  name: "Smart Living Interiors",
  tagline: "Premium Modular Kitchens & Interior Solutions",
  phone: "7899205822",
  phoneIntl: "+91 7899205822",
  whatsapp: "917899205822",
  email: "maruthiinterior@gmail.com",
  website: "www.smartlivin.in",
  city: "Bengaluru",
  address: "Nagarbhavi 1st Stage, Chandra Layout Extension II Stage, Bengaluru, Karnataka 560072",
  mapEmbed:
    "https://www.google.com/maps?q=Chandra+Layout+Extension+II+Stage+Nagarbhavi+Bengaluru+560072&output=embed",
  mapLink: "https://maps.app.goo.gl/sgfyfkS4dFodBxnX9",
  googleReviewLink: "https://maps.app.goo.gl/2rSv4TZR4ATfgJpr9",
};

const I = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;

export const IMAGES = {
  kitchen1: I("photo-1639405069836-f82aa6dcb900"),
  kitchen2: I("photo-1682662045815-9016c6225dd3"),
  kitchen3: I("photo-1600585154340-be6161a56a0c"),
  living1: I("photo-1704040686413-2c607dbd2f06"),
  living2: I("photo-1564078516393-cf04bd966897"),
  living3: I("photo-1616486338812-3dadae4b4ace"),
  wardrobe1: I("photo-1672137233327-37b0c1049e77"),
  wardrobe2: "https://images.pexels.com/photos/6580395/pexels-photo-6580395.jpeg?auto=compress&cs=tinysrgb&w=1400",
  bedroom: I("photo-1600566753086-00f18fb6b3ea"),
  dining: I("photo-1600607687939-ce8a6c25118c"),
  bath: I("photo-1620626011761-996317b8d101"),
  office: I("photo-1497366216548-37526070297c"),
  ceiling: I("photo-1503174971373-b1f69850bded"),
  crockery: I("photo-1616137466211-f939a420be84"),
  kitchen4: I("photo-1556912167-f556f1f39fdf"),
  kitchen5: I("photo-1556909212-d5b604d0c90d"),
};

export const HERO_SLIDES = [
  IMAGES.kitchen1,
  IMAGES.living1,
  IMAGES.wardrobe1,
  IMAGES.kitchen2,
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Packages", href: "#packages" },
  { label: "Process", href: "#process" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  { slug: "modular-kitchens", title: "Premium Modular Kitchens", image: IMAGES.kitchen2,
    desc: "Italian-inspired modular kitchens with matte & acrylic finishes, quartz countertops and German soft-close hardware.",
    benefits: ["Quartz & granite countertops", "Blum & Hettich hardware", "Acrylic / matte / laminate finishes", "10-year warranty"] },
  { slug: "luxury-wardrobes", title: "Luxury Wardrobes", image: IMAGES.wardrobe1,
    desc: "Sliding, hinged and walk-in wardrobes crafted with premium shutters, profile lighting and smart organisers.",
    benefits: ["Walk-in & sliding options", "Profile LED lighting", "Soft-close mechanisms", "Custom internal storage"] },
  { slug: "tv-units", title: "TV Units", image: IMAGES.living1,
    desc: "Statement entertainment units blending storage, ambient lighting and premium veneers for your living room.",
    benefits: ["Backlit panelling", "Hidden cable management", "Veneer & laminate finishes"] },
  { slug: "crockery-units", title: "Crockery Units", image: IMAGES.crockery,
    desc: "Elegant crockery and display units with glass shutters and integrated lighting.",
    benefits: ["Glass display shutters", "Integrated lighting", "Premium hardware"] },
  { slug: "false-ceiling", title: "False Ceiling", image: IMAGES.ceiling,
    desc: "Designer gypsum and POP false ceilings with cove lighting for a refined ambience.",
    benefits: ["Cove & profile lighting", "Gypsum / POP designs", "Acoustic options"] },
  { slug: "wallpaper", title: "Wallpaper", image: IMAGES.living2,
    desc: "Curated designer wallpapers and textured wall finishes from premium global brands.",
    benefits: ["Imported designer prints", "Textured finishes", "Easy maintenance"] },
  { slug: "electrical-works", title: "Electrical Works", image: IMAGES.living3,
    desc: "Concealed wiring, smart switches and lighting automation executed by certified professionals.",
    benefits: ["Smart automation ready", "Certified electricians", "Premium modular switches"] },
  { slug: "flooring", title: "Flooring", image: IMAGES.bedroom,
    desc: "Italian marble, engineered wood and luxury vinyl flooring with expert installation.",
    benefits: ["Italian marble", "Engineered wood", "Luxury vinyl"] },
  { slug: "bathroom-vanity", title: "Bathroom Vanity", image: IMAGES.bath,
    desc: "Water-resistant vanities with premium sanitaryware and elegant mirror lighting.",
    benefits: ["Water-resistant materials", "Premium sanitaryware", "Mirror lighting"] },
  { slug: "office-interiors", title: "Office Interiors", image: IMAGES.office,
    desc: "Productive, brand-forward workspaces with ergonomic furniture and acoustic design.",
    benefits: ["Ergonomic workstations", "Acoustic solutions", "Brand-led design"] },
  { slug: "commercial-interiors", title: "Commercial Interiors", image: IMAGES.office,
    desc: "Retail, hospitality and commercial fit-outs that elevate customer experience.",
    benefits: ["Retail & hospitality fit-outs", "Durable materials", "Turnkey execution"] },
  { slug: "school-furniture", title: "School Furniture", image: IMAGES.office,
    desc: "Durable, safe and ergonomic furniture solutions for educational institutions.",
    benefits: ["Child-safe design", "High durability", "Bulk manufacturing"] },
  { slug: "hospital-furniture", title: "Hospital Furniture", image: IMAGES.office,
    desc: "Hygienic, functional and compliant furniture for healthcare environments.",
    benefits: ["Antimicrobial surfaces", "Compliant design", "Functional storage"] },
  { slug: "industrial-interiors", title: "Industrial Interiors", image: IMAGES.office,
    desc: "Robust industrial interiors and workspace solutions built to last.",
    benefits: ["Heavy-duty build", "Optimised workflows", "Safety compliant"] },
  { slug: "custom-furniture", title: "Custom Furniture", image: IMAGES.living3,
    desc: "Bespoke furniture designed and manufactured to your exact specification.",
    benefits: ["Fully bespoke", "Premium materials", "In-house manufacturing"] },
];

export const PRIMARY_SLUGS = ["modular-kitchens", "luxury-wardrobes"];

export const PORTFOLIO = [
  { title: "Italian Modular Kitchen", category: "Modular Kitchens", image: IMAGES.kitchen4 },
  { title: "Acrylic Island Kitchen", category: "Modular Kitchens", image: IMAGES.kitchen1 },
  { title: "Monochrome Kitchen", category: "Modular Kitchens", image: IMAGES.kitchen2 },
  { title: "Matte Handleless Kitchen", category: "Modular Kitchens", image: IMAGES.kitchen5 },
  { title: "U-Shaped Premium Kitchen", category: "Modular Kitchens", image: IMAGES.kitchen4 },
  { title: "Compact Parallel Kitchen", category: "Modular Kitchens", image: IMAGES.kitchen1 },
  { title: "Walk-in Wardrobe", category: "Wardrobes", image: IMAGES.wardrobe1 },
  { title: "Sliding Wardrobe", category: "Wardrobes", image: IMAGES.wardrobe2 },
  { title: "Bedroom Wardrobe Unit", category: "Wardrobes", image: IMAGES.wardrobe1 },
  { title: "Backlit TV Unit", category: "TV Units", image: IMAGES.living1 },
  { title: "Luxury Villa Interior", category: "Complete Home Interiors", image: IMAGES.living2 },
  { title: "Corporate Office", category: "Commercial Projects", image: IMAGES.office },
];

export const PORTFOLIO_CATEGORIES = ["All", "Modular Kitchens", "Wardrobes", "TV Units", "Complete Home Interiors", "Commercial Projects"];

export const FLAGSHIP = {
  kitchen: {
    slug: "modular-kitchens",
    eyebrow: "Flagship · Modular Kitchens",
    title: "Custom-Designed Modular Kitchens",
    desc: "Factory-made precision meets Italian-inspired design. From acrylic and matte PU finishes to quartz countertops and German soft-close hardware — engineered for how you cook and live.",
    image: IMAGES.kitchen4,
    gallery: [IMAGES.kitchen1, IMAGES.kitchen5, IMAGES.kitchen2],
    features: [
      { title: "Premium Finishes", desc: "Acrylic, matte PU, laminate & membrane" },
      { title: "German Hardware", desc: "Blum & Hettich soft-close systems" },
      { title: "Smart Storage", desc: "Tall units, magic corners, cutlery organisers" },
      { title: "Quartz Countertops", desc: "Stain & scratch resistant surfaces" },
    ],
  },
  wardrobe: {
    slug: "luxury-wardrobes",
    eyebrow: "Flagship · Luxury Wardrobes",
    title: "Luxury Wardrobes Built for Modern Living",
    desc: "Sliding, hinged and walk-in wardrobes crafted with premium shutters, profile lighting and intelligent internal organisation — tailored to your space and lifestyle.",
    image: IMAGES.wardrobe1,
    gallery: [IMAGES.wardrobe2, IMAGES.wardrobe1, IMAGES.wardrobe2],
    features: [
      { title: "Walk-in & Sliding", desc: "Space-optimised configurations" },
      { title: "Profile LED Lighting", desc: "Sensor-based ambient lighting" },
      { title: "Smart Organisers", desc: "Pull-outs, trays & accessory units" },
      { title: "Premium Shutters", desc: "Lacquered glass, veneer & mirror" },
    ],
  },
};

export const WHY_CHOOSE = [
  { icon: "Award", title: "10+ Years Experience" },
  { icon: "Gem", title: "Premium Materials" },
  { icon: "Cog", title: "German Hardware" },
  { icon: "HardHat", title: "Professional Installation" },
  { icon: "Clock", title: "On-Time Delivery" },
  { icon: "BadgeIndianRupee", title: "Transparent Pricing" },
  { icon: "UserCheck", title: "Dedicated Project Manager" },
  { icon: "Headphones", title: "After Sales Support" },
  { icon: "ShieldCheck", title: "Warranty" },
];

export const BRANDS = ["Häfele", "Blum", "Ebco", "Hettich", "Century Ply", "Greenlam", "Merino", "Blanco"];

export const PACKAGES = [
  { name: "Basic", price: "₹2.5L+", featured: false,
    rows: { Warranty: "5 Years", Hardware: "Ebco", Materials: "MR Plywood", Accessories: "Essential", Lighting: "Basic LED", Finish: "Laminate" } },
  { name: "Standard", price: "₹4.5L+", featured: true,
    rows: { Warranty: "10 Years", Hardware: "Hettich", Materials: "BWR Plywood", Accessories: "Premium Set", Lighting: "Profile LED", Finish: "Acrylic / Laminate" } },
  { name: "Elite", price: "₹7L+", featured: false,
    rows: { Warranty: "Lifetime", Hardware: "Blum + Häfele", Materials: "BWP Marine Ply", Accessories: "Luxury Full Set", Lighting: "Smart Cove + Profile", Finish: "Matte Acrylic / PU" } },
];

export const PACKAGE_ROWS = ["Warranty", "Hardware", "Materials", "Accessories", "Lighting", "Finish"];

export const PROCESS = [
  { n: "01", title: "Consultation", desc: "We understand your vision, lifestyle and budget." },
  { n: "02", title: "Site Visit", desc: "Precise measurements and space assessment at your home." },
  { n: "03", title: "3D Design", desc: "Photo-realistic 3D designs to visualise every detail." },
  { n: "04", title: "Material Selection", desc: "Choose finishes, hardware and materials with our experts." },
  { n: "05", title: "Manufacturing", desc: "Precision manufacturing in our state-of-the-art facility." },
  { n: "06", title: "Installation", desc: "Professional installation by trained craftsmen." },
  { n: "07", title: "Quality Inspection", desc: "Rigorous multi-point quality checks before handover." },
  { n: "08", title: "Project Handover", desc: "On-time handover with warranty and after-sales support." },
];

export const REVIEWS = {
  rating: 5.0,
  total: 6,
  reviews: [
    { author: "Nithesh Shetty", rating: 5, time: "2 months ago", verified: true,
      text: "I'm writing this review two months after the completion of my home interior work. Chandan stands out for his professional approach. He takes the time to truly understand the customer's requirements before offering genuine suggestions. What impressed me most was his commitment to timelines. The skilled team was highly experienced, and the craftsmanship was both neat and clean. They offer flexible options ranging from basic to premium. Overall, it was a smooth and satisfying experience. Highly recommend." },
    { author: "Sachin Shanbhag", rating: 5, time: "3 years ago", verified: true,
      text: "Excellent! That's what I feel about them in one word. When I planned to start the interiors of my house, I was searching for the best options who can understand my thoughts and deliver the best. Great thought process, ideas, quality, professionalism and commitment. I got my house delivered on the day they promised. They have a very skilled team. Whenever there is any small issue, they respond and address it on time. I recommend them to all those planning interiors for their dream home." },
    { author: "Shrinivas M.S", rating: 5, time: "5 years ago", verified: true,
      text: "We got our new 3BHK interior work done here. We were provided with a detailed design before starting the actual work. Quality of the work is really appreciated. Great commitment to finish the job on time. High quality work with reasonable price. We are completely satisfied with the service. Would highly recommend their services. Keep up the good work." },
    { author: "Arjun Chundiran", rating: 5, time: "a year ago", verified: true,
      text: "Chandan did a good job building the partition and false ceiling for my space. He handled the entire process from start to finish, ensuring the work was completed as expected. The structure is solid, and the final result meets my needs. If you're looking for someone to get the job done, Chandan is a reliable choice." },
    { author: "Jessie Priyanka", rating: 5, time: "2 years ago", verified: true,
      text: "We got our interiors completed here. The work completed is very professional and exceeded our expectations. Nagbhushan sir and team were very helpful in meeting each of our requirements. Thank you team!" },
    { author: "Dayanand M", rating: 5, time: "6 years ago", verified: true,
      text: "I have got the best service from this company. Delivered on time, agreed quality and totally worth it. Thanks guys, keep the good work up." },
  ],
};

export const STATS = [
  { value: 500, suffix: "+", label: "Completed Projects" },
  { value: 1000, suffix: "+", label: "Happy Clients" },
  { value: 10, suffix: "+", label: "Years Experience" },
  { value: 98, suffix: "%", label: "Client Satisfaction" },
];

export const PROJECT_TYPES = ["Modular Kitchen", "Wardrobe", "Full Home Interior", "TV Unit", "False Ceiling", "Office / Commercial", "Other"];
export const BUDGETS = ["Under ₹2L", "₹2L – ₹5L", "₹5L – ₹10L", "₹10L – ₹20L", "₹20L+"];

// Kitchen cost estimator config (rule-based)
export const ESTIMATOR = {
  layouts: [
    { key: "L-Shaped", factor: 1 },
    { key: "U-Shaped", factor: 1.25 },
    { key: "Parallel", factor: 1.1 },
    { key: "Straight", factor: 0.8 },
    { key: "Island", factor: 1.5 },
  ],
  finishes: [
    { key: "Laminate", rate: 1100 },
    { key: "Acrylic", rate: 1800 },
    { key: "Matte PU", rate: 2400 },
    { key: "Membrane", rate: 1500 },
  ],
  sizes: [
    { key: "Compact (up to 80 sq.ft)", area: 80 },
    { key: "Medium (80–120 sq.ft)", area: 110 },
    { key: "Large (120–160 sq.ft)", area: 150 },
    { key: "Premium (160+ sq.ft)", area: 200 },
  ],
  addons: [
    { key: "Tall Unit", cost: 45000 },
    { key: "Breakfast Counter", cost: 30000 },
    { key: "Profile Lighting", cost: 25000 },
    { key: "Chimney + Hob", cost: 55000 },
  ],
};
